import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { AuthService } from '../../services/auth/auth.service';
import { ISettingsConfigComponent } from '../../models/util/settingsConfig';
import { UserService } from '../../services/user/user.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from '../../services/toaster/toaster.service';
import { ToasterTypeEnum } from '../../enums/toasterType.enum';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-settings-account',
	standalone: true,
	imports: [
		MaterialModule,
		FormsModule,
		PipesModule,
		ReactiveFormsModule
	],
	templateUrl: './settings-account.component.html',
	styleUrl: './settings-account.component.scss'
})
export class SettingsAccountComponent implements ISettingsConfigComponent, OnInit, OnDestroy {

	private readonly authService = inject(AuthService);
	private readonly userService = inject(UserService);
	private readonly activatedRoute = inject(ActivatedRoute);
	private readonly toasterService = inject(ToasterService);

	user = this.activatedRoute.snapshot.data['userData'];
	originalUser = {
		name: this.activatedRoute.snapshot.data['userData']?.name,
		lastName: this.activatedRoute.snapshot.data['userData']?.lastName
	};
	changesSaved: boolean = false;
	isFormTouched: boolean = false;
	form: FormGroup;
	hasNameOrLastNameChanged: boolean = false;
	subscription: Subscription;

	constructor() {
		this.form = new FormGroup({
			name: new FormControl(this.user?.name || '', [Validators.required]),
			lastName: new FormControl(this.user?.lastName || '', [Validators.required])
		});
	}

	ngOnInit(): void {
		this.subscription = this.form.valueChanges.subscribe(() => {
			this.hasNameOrLastNameChanged = this.form.get('name')?.value !== this.user?.name || this.form.get('lastName')?.value !== this.user?.lastName;
		});
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	hasDataChanged(): boolean {
		return ((this.form.value?.['name'] !== this.originalUser?.['name']) || (this.form.value?.['lastName'] !== this.originalUser?.['lastName'])) && !this.changesSaved && this.hasNameOrLastNameChanged;
	}

	async save(): Promise<void> {
		if (this.form.invalid) {
			return;
		}

		this.user.name = this.form.value.name;
		this.user.lastName = this.form.value.lastName;

		this.changesSaved = true;
		try {
			await this.userService.save(this.user, environment.projectId);
			this.changesSaved = true;
			this.hasNameOrLastNameChanged = false;
			this.toasterService.show('account.account_updated_successfully', ToasterTypeEnum.SUCCESS);
			this.authService.auth.user = this.user;
		} catch (error) {}
	}

}
